module.exports = __webpack_public_path__ + "img/jxk_zjdx.ec6263e6.svg";